import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";

import {getObjectLength} from "../../../../utils/functions"
import * as func from "../../../../utils/functions";
import {BASE_PATH} from "../../../../wpconfig";
import {NavLink} from "react-router-dom";
import Loading from "../../../etc/loading";

class JournalSide extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const fullText = this.props.fullText;
		const record = this.props.record;
		const similar = this.props.similar;

		return (
			<div className="right-side-group">
				{/*{!similar ? <Loading/> :*/}
				{/*	(similar && similar.length > 0) &&*/}
					<div>
						<h4 className="con-title d-flex align-items-center mb-3">
							<span className="icon icon-size-16 icon-link-blue mr-2" />최신 보고서
						</h4>
						<div>
							<div className="dot-text-list">
								<div className="list-cell">준비중</div>
								{/*{similar.map((item, index) => {*/}
								{/*	return (*/}
								{/*		<div key={index} className="list-cell">*/}
								{/*			/!*<a href={BASE_PATH + "journal/?record_id=" + item.journal_id} target="_blank">{item.journal_title}</a>*!/*/}
								{/*			<NavLink to={BASE_PATH + "journal/?record_id=" + item.journal_id}>{item.journal_title}</NavLink>*/}
								{/*		</div>*/}
								{/*	)*/}
								{/*})}*/}
							</div>
						</div>
					</div>
				{/*}*/}
				{fullText.length > 0 &&
				<div className="mt-px-20 pt-px-20 border-top border-lightgray">
					<h4 className="con-title d-flex align-items-center mb-3">
						<span className="icon icon-size-16 icon-link-blue mr-2" />Full Text</h4>
					<div>
						<div className="dot-text-list">
							{fullText.map((item, num) => {
								return (<div className="list-cell" key={num}><a href={item.url} target="_blank">{item.name}</a></div>)
							})}
						</div>
					</div>
				</div>
				}
				<div className="mt-px-20 pt-px-20 border-top border-lightgray">
					<h4 className="con-title d-flex align-items-center mb-3">
						<span className="icon icon-size-16 icon-link-blue mr-2" />Extra Link</h4>
					<div>
						<div className="dot-text-list">
							{record.wos_id &&
							<div className="list-cell">
								<a href={"https://jcr.clarivate.com/jcr-jp/journal-profile?journal="+record.wos_id+"&year=All%20years"} target="_blank">JCR Journal</a>
							</div>}
							{record.scopus_id &&
							<div className="list-cell">
								<a href={"https://www.scopus.com/sourceid/"+record.scopus_id} target="_blank">SCOPUS Journal</a>
							</div>}
							{record.kci_id &&
							<div className="list-cell">
								<a href={"https://www.kci.go.kr/kciportal/po/search/poCitaView.kci?sereId="+record.kci_id} target="_blank">KCI Journal</a>
							</div>}
							{record.journal_category && record.journal_category.map((item, num) => {
								if (item.category_type.includes('kci')) {
									const url = rmVars.proxyUrl + rmVars.kciJournalUrl + record.issn;
									return (<div key={num} className="list-cell"><a href={url} target="_blank">KCI</a></div>);
								} else if (item.category_type.includes('scopus')) {
									const url = rmVars.proxyUrl + rmVars.scopusJournalUrl + record.issn;
									return (<div key={num} className="list-cell"><a href={url} target="_blank">Scopus</a></div>);
								} else {
									const url = rmVars.proxyUrl + rmVars.jcrJournalUrl + record.issn;
									return (<div key={num} className="list-cell"><a href={url} target="_blank">JCR</a></div>);
								}
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect(
	(state) => ({
		fullText: state.journals.fullText ? state.journals.fullText : [],
		record: state.journals.record ? state.journals.record : [],
		similar: state.journals.similar ? state.journals.similar : null,
	}),
	(dispatch) => ({
		// dataActions: bindActionCreators(Actions, dispatch)
	}),
)(JournalSide)

JournalSide.propTypes = {
	fullText: PropTypes.array,
};
